import { render, staticRenderFns } from "./UserModalFooter.vue?vue&type=template&id=7e5fac95&scoped=true"
import script from "./UserModalFooter.vue?vue&type=script&lang=js"
export * from "./UserModalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5fac95",
  null
  
)

export default component.exports